import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import { ModeloVistoriaApiService } from '../../../editar-modelo-vistoria/services/modelo-vistoria-api.service';
import { VistoriaApiService } from '../../../realizar-vistoria/services/vistoria-api.service';
import { Vistoria } from '../../../realizar-vistoria/models/vistoria';
import { DownloadService } from '@services/download.service';

@Component({
  selector: 'app-visualizacao-template-html',
  standalone: false,
  templateUrl: './visualizacao-template-html.component.html',
  styleUrl: './visualizacao-template-html.component.scss'
})
export class VisualizacaoTemplateHtmlComponent implements OnInit {

  @Input() html = '';
  @Input() modeloId: number | null = null;
  @Input() vistoria: Vistoria | null = null;

  htmlVisualizado: SafeHtml | null = null;
  baixandoPdf = false;

  // Largura do iframe nunca se ajusta ao conteúdo (fica fixa em 210mm) — overflow horizontal
  // aparece cortado aqui do mesmo jeito que cortaria no PDF real, em vez de escondido atrás de
  // uma scrollbar. Altura é medida e ajustada (onIframeLoad) porque múltiplas páginas empilhadas
  // é comportamento normal, não bug — sem isso o preview cortaria o relatório inteiro por engano.
  iframeHeightPx = 1123;

  constructor(
    private modeloVistoriaApiService: ModeloVistoriaApiService,
    private vistoriaApiService: VistoriaApiService,
    private downloadService: DownloadService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.atualizar();
  }

  public atualizar(): void {
    // O HTML tem sintaxe Scriban ({{ for }}/{{ if }}) — precisa passar pelo backend pra resolver
    // os loops com dados de preview antes de exibir; não dá pra só religar o srcdoc localmente.
    const renderizar$: Observable<{ html: string }> = this.vistoria
      ? this.vistoriaApiService.renderizarTemplateHtml({ ...this.vistoria, templateHtml: this.html })
      : this.modeloVistoriaApiService.renderizarTemplateHtml(this.modeloId!, this.html);

    renderizar$.subscribe({
      next: (resultado) => {
        // bypassSecurityTrustHtml só vale pra essa binding: o iframe abaixo tem
        // sandbox="allow-same-origin" (sem allow-scripts), então <script> no HTML continua
        // inerte, mesmo lendo a altura do documento em onIframeLoad.
        // Precisa entrar dentro do <head>, não antes do <!DOCTYPE> — colar antes quebra o modo
        // de renderização padrão do navegador (quirks mode), que bagunça o scrollHeight medido
        // em onIframeLoad. Se não achar <head> (HTML customizado sem essa tag), não injeta nada.
        const estiloSemScroll = '<style>html, body { overflow: hidden !important; }</style>';
        const htmlSemScrollProprio = resultado.html.includes('<head>')
          ? resultado.html.replace('<head>', `<head>${estiloSemScroll}`)
          : resultado.html;
        this.htmlVisualizado = this.sanitizer.bypassSecurityTrustHtml(htmlSemScrollProprio);
      },
      error: () => { }
    });
  }

  public onIframeLoad(event: Event): void {
    const documento = (event.target as HTMLIFrameElement).contentDocument;
    const altura = documento?.documentElement?.scrollHeight;
    if (altura) this.iframeHeightPx = altura;
  }

  public baixarPdf(): void {
    this.baixandoPdf = true;
    const gerarPdf$: Observable<Blob> = this.vistoria
      ? this.vistoriaApiService.gerarPdfPreview({ ...this.vistoria, templateHtml: this.html })
      : this.modeloVistoriaApiService.gerarPdfPreview(this.modeloId!, this.html);

    gerarPdf$.subscribe({
      next: (blob) => {
        this.downloadService.downloadFile(new File([blob], 'laudo-preview.pdf', { type: 'application/pdf' }), 'laudo-preview.pdf');
        this.baixandoPdf = false;
      },
      error: () => { this.baixandoPdf = false; }
    });
  }
}
